import { Footer, PageLayout, Strip, Typography } from '@bharatpe/bharat-ui';
import React, { useEffect } from 'react';
import { closeNativeSupport } from 'utils/nativeSupport';
import { Info } from '@bharatpe/bharat-ui/web/Icons';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import history from 'utils/History';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

const DelinkSuccess: React.FC = () => {
	const { languageData } = useLanguageConfig();

	useEffect(() => {
		logAnalyticsEvent({
			trigger_point: 'Page View',
			Product: 'AutoPayUPI',
			Flow: 'Setting',
			Screen: 'Loan_closed',
			Module: 'Page',
			Action: 'Viewed',
		});
	}, []);
	return (
		<PageLayout
			className="pb18 white-background content-center"
			footerContent={
				<Footer primaryActionText="DONE" primaryAction={() => history.push({ pathname: '/account/upi-settings' })} />
			}>
			<div className="flex flex-column mx5">
				<Typography variant="SemiBold700" className="text-center">
					{languageData.ACCOUNT_UNLINKED}
				</Typography>
				<Typography variant="Regular200" className="text-center grey mt1">
					{languageData.YOUR_ACCOUNT_REGISTERED_FOR_AUTO_PAY_HAS_BEEN_UNLIKED_SUCCESSFULLY}
				</Typography>
				<Strip
					className="mt5"
					customIcon={{
						height: 20,
						icon: Info,
					}}>
					<Typography variant="Regular200" className="primary">
						{languageData.YOU_CAN_REGISTER_FOR_AUTO_PAY_AGAIN_USING_THE_SAME_BANK_DETAILS}
					</Typography>
				</Strip>
			</div>
		</PageLayout>
	);
};
export default DelinkSuccess;
